import {
  Button,
  Layout,
  theme,
  Form,
  Input,
  Select,
  Spin,
  notification,
} from "antd";

import React, { useState, useEffect, useCallback } from "react";
import "../CreateRole/CreateRole.css";

import { Row, Col } from "antd";
import { Link, useNavigate } from "react-router-dom";
import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
// import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import SuppliersApi from "../../common/Apis/SuppliersApi";
import DepartmentsApi from "../../common/Apis/DepartmentsApi";
import DepartmentDropdown from "../../common/DropDowns/Department";

const EditSuppliers = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const urlParams = new URLSearchParams(window.location.search);
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const id = urlParams.get("id");
  const { Content } = Layout;
  const [loadings, setLoadings] = useState(false);
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const handleGoBack = () => {
    navigate(-1);
  };
  const [Suppliers, setSuppliers] = useState();

  const [isLoading, setIsLoading] = useState(false);
  const PageLoading = useCallback(() => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
  }, []);

  const getSingleSupplier = useCallback(() => {
    SuppliersApi.SingleSuppliers(id)
      .then((response) => {
        console.log(response);
        setSuppliers(response.payload);
        form.setFieldsValue({
          supplierName: response?.payload?.supplierName,
          description: response?.payload?.description,
          address: response?.payload?.address,
          institutionId: response?.payload?.institutionDTO?.id,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);




  useEffect(() => {
    PageLoading();
    getSingleSupplier();
  }, [PageLoading, getSingleSupplier]);

  const handleSubmit = (data) => {
    setLoadings(true);
    let formData = JSON.stringify({
      id: id,
      supplierName: data.supplierName,
      description: data.description,
      address: data.address,
      tenantDTO: {
        id: decodedToken?.tenantId,
        tenantApiKey: decodedToken?.tenantApiKey,
      },
      institutionDTO: {
        id: data.institutionId,
      },
    });
    SuppliersApi.EditSuppliers(id, formData)
      .then((response) => {
        setLoadings(false);
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Updated</span>,
          description: "Update Successfully",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        return navigate("/masters/suppliers");
      })
      .catch((err) => {
        if (err.apiError.status) {
          setLoadings(false);
          notification.open({
            message: <span style={{ fontWeight: "bold" }}>Error</span>,
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader />
        {isLoading && (
          <div className="spinner-overlay" id="spinnerOverlay">
            <div className="spinner"></div>
          </div>
        )}

        <Content
          className="form-content nav-content"
          style={{
            margin: "16px 16px 0",
            padding: "30px",
            background: colorBgContainer,
          }}
        >
          <Form
            form={form}
            name="nest-messages"
            layout="vertical"
            className="FormClass"
            onFinish={handleSubmit}
          >
            <>
              <Row gutter={16}>
                <Col lg={8} md={12}>
                  <Form.Item
                    name="supplierName"
                    label="Supplier Name"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Supplier Name.",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="Supplier Name"
                      className="control-input"
                    />
                  </Form.Item>
                </Col>
                <Col lg={8} md={12}>
                  <Form.Item
                    name="description"
                    label="Description"
                    className="text-lable"
                  >
                    <Input
                      type="text"
                      placeholder="Description"
                      className="control-input"
                    />
                  </Form.Item>
                </Col>
                <Col lg={8} md={12}>
                  <Form.Item
                    name="address"
                    label="Address"
                    className="text-lable"
                  >
                    <Input
                      type="text"
                      placeholder="Supplier Address"
                      className="control-input"
                    />
                  </Form.Item>
                </Col>
                <Col lg={8} md={12}>
                  <DepartmentDropdown />
                </Col>
              </Row>

              <div className="d-flex justify-content-end pt-5">
                <Link
                  type="primary"
                  to={""}
                  onClick={handleGoBack}
                  className="btn btn-primary btn-back"
                >
                  Back
                </Link>

                <Button
                  type="primary"
                  htmlType="submit"
                  className="btn btn-primary btn-save"
                >
                  Update {loadings == true && <Spin className="px-2" />}
                </Button>
              </div>
            </>
          </Form>
        </Content>
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};
export default EditSuppliers;
